<template>
  <div class="right-table-3 p-2">
    <div class="bc-chart-item table h-full">
      <div class=""></div>
      <div id="risk-pie" style="height: 100%; width: 460px"></div>
      <DialogUserTable
        :show.sync="visible"
        :tableData="filterList"
        @onSelect="onCheckoutItemOfUser"
      ></DialogUserTable>
      <DialogArchivesCard
        :id="checkUsers.sn"
        :show.sync="visibleArchives"
        @back="visible = true"
      ></DialogArchivesCard>
    </div>
    <!-- </dv-border-box-13> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ComponentSubtitle from "./ComponentSubtitle.vue";
import DialogUserTable from "./DialogUserTable.vue";
import DialogArchivesCard from "./DialogArchivesCard.vue";
import * as echarts from "echarts";

export default {
  computed: {
    ...mapGetters(["globalData", "mapKey", "communityKey", "plotKey"]),
  },
  data() {
    return {
      config: {
        header: [],
        data: [],
        align: ["center"],
      },
      visible: false,
      list: [],
      filterList: [],
      visibleArchives: false,
      checkUsers: {},
    };
  },
  watch: {
    globalData: {
      handler(n, o) {
        this.$nextTick(async () => {
          this.list = this.globalData["users"] || [];
          // this.filterList = this.globalData["users"];
          this.initChart();
        });
      },
    },
  },
  components: {
    ComponentSubtitle,
    DialogUserTable,
    DialogArchivesCard,
  },
  methods: {
    initTable() {
      let userList = this.globalData["users"];

      let rows = userList.map((v) => {
        return [
          v.name,
          v.gender,
          v.age,
          v.address,
          this.formatRiskLevel(v.riskLevel),
        ];
      });
      let config = {
        header: [
          "<span style='color: #abd1e7'>姓名</span>",
          "<span style='color: #abd1e7'>性别</span>",
          "<span style='color: #abd1e7'>年龄</span>",
          "<span style='color: #abd1e7'>住址</span>",
          "<span style='color: #abd1e7'>评估结果</span>",
        ],
        data: rows,
        // carousel: "page", // 全页滚动
        headerBGC: "none",
        oddRowBGC: "none",
        evenRowBGC: "none",
      };
      this.config = config;

      // this.$refs["scrollBoard"].updateRows(rows);
    },
    onCheckoutItemOfUser(row) {
      this.checkUsers = row;
      // this.getArchivesDetail();
      this.visible = false;
      this.visibleArchives = true;
      return;
    },

    formatRiskLevel(level = 1) {
      let map = new Map([
        [0, `<span style="color:#34C724;">基本健康人群</span>`],
        [1, `<span style="color:#34C724;">基本健康人群</span>`],
        [2, `<span style="color:#FF8800;">专项关爱人群</span>`],
        [3, `<span style="color:#F54A45;">重点关爱人群</span>`],
      ]);
      return map.get(level);
    },
    initChart() {
      let userList =
        this.globalData["riskChart"] && this.globalData["riskChart"].seriesData;
      var getname = ["基本健康人群", "专项关爱人群", "重点关爱人群"];
      
      let getvalue = [
        userList && userList.find(v => v.name == '基本健康人群').data.at(-1),
        userList && userList.find(v => v.name == '专项关爱人群').data.at(-1),
        userList && userList.find(v => v.name == '重点关爱人群').data.at(-1),
      ];
      
      // userList.map((v) => {
      //   if (v.riskLevel == 2) {
      //     getvalue[1] += 1;
      //   } else if (v.riskLevel == 3) {
      //     getvalue[2] += 1;
      //   } else {
      //     getvalue[0] += 1;
      //   }
      // });
      let total = (userList[2].data.at(-1) + userList[1].data.at(-1) + userList[0].data.at(-1));
      var getbl = getvalue.map((v) => (v / total) * 100);
      let num1 = this.globalData["total"];
      let sum1 = parseInt((getvalue[0]  / total) * 100);
      
      let sum2 = parseInt( (getvalue[1] / total) * 100);
      let sum3 = 100 - (sum1 + sum2);
      
      let sumArray = [sum1, sum2, sum3];
      let valueArray = [num1 * (sum1 / 100), num1 * (sum2 / 100), num1 - (num1 * (sum1 / 100) +  num1 * (sum2 / 100)) ];
      console.log("sumArray", sumArray);
      console.log("valueArray", valueArray);

      
      var data = [];
      let that = this;
      for (var i = 0; i < getname.length; i++) {
        data.push({ name: getname[i], value: getvalue[i] });
      }

      var colorList = ["#34C724", "#FF8800", "#F54A45"];

      let option = {
        tooltip: {
          trigger: "item",

          show: true,
        },

        legend: {
          type: "scroll",

          orient: "vertical",

          height: "88%",

          right: "6%",

          top: "center",

          icon: "circle",

          itemWidth: 10,

          itemHeight: 10,

          itemGap: 10,

          data: getname,
          color: "#fff",
          formatter: function (name, list) {
            for (var i = 0; i < getname.length; i++) {
              if (name == data[i].name) {
                  let value =Number(valueArray[i].toFixed(0));
                  return (
                    "{name|" +
                    name +
                    "}{value|" + value
                    +
                    "人}{rate|" +
                     sumArray[i].toFixed(0)+
                    "%}"
                  );
              }
            }
          },

          textStyle: {
            rich: {
              name: {
                fontSize: 13,

                fontWeight: 400,

                width: 80,

                height: 35,

                padding: [0, 0, 0, 10],

                // color: "#6395CA",
                color: this.$color.borderColor,
              },

              value: {
                fontSize: 13,

                fontWeight: 400,

                width: 50,

                height: 35,

                //padding:[0,0,0,1],

                // color: "#6395CA",
                color: this.$color.borderColor,
              },

              rate: {
                fontSize: 13,

                fontWeight: 500,

                height: 35,

                width: 55,

                align: "left",

                // color: "#6395CA",

                color: this.$color.borderColor,
              },
            },
          },
        },

        series: [
          {
            type: "pie",

            radius: ["45%", "75%"],

            center: ["25%", "50%"],

            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex];
                },
              },
            },

            label: {
              normal: {
                show: false,
              },
            },

            labelLine: {
              normal: {
                show: false,
              },
            },

            data: data,
          },
        ],
      };
      var myChart = echarts.init(document.getElementById("risk-pie"));
      myChart.setOption(option);
      myChart.on("click", async (params) => {
        console.log(params);
        if (params.name == "基本健康人群") {
          // this.filterList = this.list.filter(
          //   (v) => !v.riskLevel || v.riskLevel == 1
          // );
          this.getRiskUsers(1);
        }
        if (params.name == "专项关爱人群") {
          // this.filterList = this.list.filter((v) => v.riskLevel == 2);
          this.getRiskUsers(2);
        }
        if (params.name == "重点关爱人群") {
          // this.filterList = this.list.filter((v) => v.riskLevel == 3);
          this.getRiskUsers(3);
        }
      });
    },
    getRiskUsers(riskLevel) {
      this.$axios
        .get("/statisticsService/mechanism/survey/riskUsers", {
          params: {
            subDistrict: this.mapKey,
            community: this.communityKey,
            village: this.plotKey,
            riskLevel,
          },
        })
        .then((resp) => {
          this.filterList = resp.data;
          this.visible = true;
        });
    },
  },
  mounted() {
    // this.initTable();
  },
};
</script>
<style lang="less" scoped>
.right-table-3 {
  height: 100%;
  // background-color: rgba(243, 243, 243, 0) !important;
}
.table {
  // padding: 20px 0px 0 0;
}
</style>
